// Alle Preise stehen hier an einer einzigen Stelle. Werden Preise geändert, nur hier anpassen.
// Wichtig: Die Bestellmail des Servers übernimmt die Beträge, die die Webseite schickt.
// pricing.js – Preisberechnung (an einer Stelle für Preisfenster und Bestellung)

// Packs: Platz für so viele Personen, Preis pro Exemplar
export const PACKS = [
  { size: 12, price: 36.95 },
  { size: 24, price: 44.95 },
  { size: 36, price: 52.95 },
];
export const LIEFERKOSTEN = 10;     // pro Bestellung (wird später genauer definiert)
export const RETOUCH_PRICE = 5;     // pro Bild, das von Hand bearbeitet wird (einmalig)

// Günstigste Kombination von Packs, die alle Personen fasst (auch über 36 Personen)
// Probiert alle Kombinationen aus 12er-, 24er- und 36er-Packs, die genug Platz
// für alle Personen haben, und nimmt die billigste.
// Beispiel 40 Personen: 36er + 12er = 89.90, 2× 24er = 89.90, 36er + 24er = 97.90,
// 2× 36er = 105.90. Bei gleichem Preis gewinnt die zuerst gefundene Kombination
// (grosse Packs werden zuerst probiert) – hier also 36er + 12er.
// Technik: „Suche mit Rückverfolgung“ (search ruft sich selbst auf). Ist eine
// Teil-Kombination schon teurer als die beste bisher, wird sie nicht weiter verfolgt.
export function cheapestPacks(persons) {
  let best = { price: Infinity, packs: [] };
  const sorted = [...PACKS].sort((a, b) => b.size - a.size);
  // remaining = noch unterzubringende Personen, packs = bisher gewählte Packs,
  // cost = Preis bisher, start = ab welchem Pack weiterprobiert wird.
  (function search(remaining, packs, cost, start) {
    if (cost >= best.price - 1e-9) return;
    if (remaining <= 0) { best = { price: cost, packs: [...packs] }; return; }
    for (let i = start; i < sorted.length; i++) {   // nur Kombinationen, keine Wiederholungen in anderer Reihenfolge
      packs.push(sorted[i]);
      search(remaining - sorted[i].size, packs, cost + sorted[i].price, i);
      packs.pop();
    }
  // Startwert: mindestens 1 Person, noch keine Packs, Preis 0.
  })(Math.max(1, persons), [], 0, 0);
  // Auf Rappen runden (gegen Rundungsfehler wie 89.89999999).
  best.price = Math.round(best.price * 100) / 100;
  return best;
}

// „36er + 12er“ bzw. „2× 24er“
// Zählt gleiche Packs zusammen und baut den Text, grösste Packs zuerst.
export function packSummary(packs) {
  const counts = {};
  packs.forEach(p => { counts[p.size] = (counts[p.size] || 0) + 1; });
  return Object.keys(counts).sort((a, b) => b - a)
    .map(size => (counts[size] > 1 ? `${counts[size]}× ` : '') + `${size}er-Pack`).join(' + ');
}

// „2× 36er-Pack“ (1 Exemplar) bzw. „3 Exemplare à 2× 36er-Pack (105.90 CHF)“
// Text für die Preiszeile im Preis- und Bestellfenster.
export function packLine(copies, price) {
  const packs = packSummary(price.packs);
  return copies === 1 ? packs : `${copies} Exemplare à ${packs} (${fmt(price.packPrice)})`;
}

// Gesamtpreis einer Bestellung:
//   packPrice = Preis für EIN Exemplar (günstigste Pack-Kombination)
//   druck     = packPrice × Anzahl Exemplare
//   retouch   = Bilder, die von Hand bearbeitet werden × 5 CHF
//   liefer    = Lieferkosten (einmal pro Bestellung)
export function calcPrice({ persons, copies = 1, retouchCount = 0 }) {
  const { price: packPrice, packs } = cheapestPacks(persons);
  const druck = round(packPrice * copies);
  const retouch = round(retouchCount * RETOUCH_PRICE);
  const liefer = LIEFERKOSTEN;
  return { packPrice, packs, druck, retouch, liefer, total: round(druck + retouch + liefer) };
}

// Hilfsfunktionen: auf 2 Stellen runden bzw. als „52.95 CHF“ formatieren.
function round(v) { return Math.round(v * 100) / 100; }
export function fmt(v) { return v.toFixed(2) + ' CHF'; }
